import EntityExplorer from "./entity-explorer/EntityExplorer.vue";
import SEGFrameBuilder from "./seg-frame-builder/SEGFrameBuilder.vue";


export default {
    'entity-explorer': EntityExplorer,
    'seg-frame-builder': SEGFrameBuilder,
};